import { useCallback, useEffect } from 'react';
import { usePublishDraftJobPost } from '~/domain/PermanentJobs';
import { showErrorMessage } from '~/domain/utils';

interface IUsePublishJobPostPayload {
  jobPostingId?: string;
  onSuccess?: () => void;
}

export const usePublishJobPost = ({ jobPostingId, onSuccess }: IUsePublishJobPostPayload) => {
  const { error, isError, isPending, mutate } = usePublishDraftJobPost();

  useEffect(() => {
    if (isError) {
      showErrorMessage({ error });
    }
  }, [error, isError]);

  const doPublish = useCallback(() => {
    if (!jobPostingId) {
      return;
    }

    mutate(jobPostingId, {
      onSuccess,
    });
  }, [jobPostingId, mutate, onSuccess]);

  return {
    isLoading: isPending,
    doPublish,
  };
};
